module.exports = __webpack_public_path__ + "img/1552154307.cb31adde.jpg";